<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto is-marginless"
      :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="newCritereRecherche.dates"
            :label="$t('listeDemandeImpression.filtre.date')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeDemandeImpression.filtre.etat')"
                      :items="constantes.ETAT_DEMANDE_IMPRESSION"
                      v-model="etatDemandeImpressionSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeDemandeImpression.filtre.couleurs')"
                      :items="constantes.COULEUR_IMPRESSION"
                      v-model="couleurImpressionSelected">
          </libelle-tag-input>
        </div>
      </div>
      <div class="column is-12 pdb-0"
        v-if="societesInformations.length > 1 && !filtrerProduitParSociete">
        <b-field :label="$t('addProduitsAssocies.filtre.societe')">
          <b-select v-model="societeId" expanded>
            <option :value=null></option>
            <option v-for="societe in societesInformations"
                    :key="societe.id"
                    :value="societe.id">
              {{ societe.libelle }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeDemandeImpression.filtre.client')">
          <qd-taginput v-if="filteredClients"
                      v-model="clientSelected"
                      :data="filteredClients"
                      autocomplete
                      open-on-focus
                      icon="magnify"
                      type="is-primary"
                      field="nomCommercial"
                      @typing="getFilteredClientTags">
            <template slot="empty">
              {{$t('general.autocomplete.noRslt')}}
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeDemandeImpression.filtre.demandeur')">
          <qd-taginput v-if="filteredDemandeurs"
                      v-model="demandeurSelected"
                      :data="filteredDemandeurs"
                      autocomplete
                      open-on-focus
                      icon="magnify"
                      type="is-primary"
                      field="prenomNom"
                      @typing="getFilteredDemandeurTags">
            <template slot="empty">
              {{$t('general.autocomplete.noRslt')}}
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeDemandeImpression.filtre.receveur')">
          <qd-taginput v-if="filteredReceveurs"
                      v-model="receveurSelected"
                      :data="filteredReceveurs"
                      autocomplete
                      open-on-focus
                      icon="magnify"
                      type="is-primary"
                      field="prenomNom"
                      @typing="getFilteredReceveurTags">
            <template slot="empty">
              {{$t('general.autocomplete.noRslt')}}
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeDemandeImpression.filtre.dispositif')">
          <qd-taginput v-if="filteredDispositifs"
                      v-model="dispositifSelected"
                      :data="filteredDispositifs"
                      autocomplete
                      open-on-focus
                      icon="magnify"
                      type="is-primary"
                      field="code"
                      @typing="getFilteredDispositifTags">
            <template slot="empty">
              {{$t('general.autocomplete.noRslt')}}
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeDemandeImpression.filtre.campagne')">
          <qd-taginput v-if="filteredCampagnes"
                      v-model="campagneSelected"
                      :data="filteredCampagnes"
                      autocomplete
                      open-on-focus
                      icon="magnify"
                      type="is-primary"
                      field="libelle"
                      @typing="getFilteredCampagnesTags">
            <template slot="empty">
              {{$t('general.autocomplete.noRslt')}}
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <user-tag-input
          :label="$t('listeDemandeImpression.filtre.graphiste')"
          v-model="graphisteSelected"
        />
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input
          :label="$t('listeDemandeImpression.filtre.tag')"
          v-model="tagSelected"
          :query="getTags">
          <template slot-scope="props">
            {{ props.option.libelle }}
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeDemandeImpression.filtre.materielTypeLibelles')">
          <qd-taginput
            v-model="newCritereRecherche.materielTypeLibelles"
            type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.appliquer')}}</button>

      <button
        class="mgt-10px button border-none has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import genererCritereRechercheDemandeImpression
  from '@/services/logistique/demandeImpression/genererCritereRechercheDemandeImpression';
import {
  COULEUR_IMPRESSION,
  ETAT_DEMANDE_IMPRESSION,
} from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import { getAllWithTiers as getAllContact } from '@/api/contacts';
import { getAll as getAllTiers } from '@/api/tiers';
import { getAll as getAllDispositif } from '@/api/gabed/dispositif';
import { getAll as getAllCampagnes } from '@/api/campagne';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { SET_CRITERES } from '@/store/modules/logistique/demandeImpression-mutation-type';
import userTagInput from '@/components/commun/user/userTagInput';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import { getAll as getAllTags } from '@/api/tag/index';
import { DEMANDE_IMPRESSION } from '@/configuration/parametrage/tagConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const DemandeImpression = createNamespacedHelpers('demandeImpression');
const user = createNamespacedHelpers('user');

export default {
  name: 'filtrelisteDemandeImpression',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newCritereRecherche: null,
      errors: [],
      constantes: {
        ETAT_DEMANDE_IMPRESSION,
        COULEUR_IMPRESSION,
        DEMANDE_IMPRESSION,
      },
      isFetchingDemandeurs: false,
      isFetchingReceveurs: false,
      isFetchingClients: false,
      isFetchingDispositif: false,
      isFetchingCampagne: false,
      etatDemandeImpressionSelected: [],
      couleurImpressionSelected: [],
      filteredDemandeurs: [],
      filteredReceveurs: [],
      filteredClients: [],
      filteredDispositifs: [],
      filteredCampagnes: [],
      demandeurSelected: [],
      receveurSelected: [],
      clientSelected: [],
      dispositifSelected: [],
      campagneSelected: [],
      graphisteSelected: [],
      tagSelected: [],
      societeId: null,
    };
  },
  components: {
    queryTagInput,
    libelleTagInput,
    errorMsgComponent,
    inputPeriode,
    userTagInput,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...DemandeImpression.mapMutations({
      setCritereRecherche: SET_CRITERES,
    }),
    appliquerCritere() {
      this.newCritereRecherche.etats = this.etatDemandeImpressionSelected.map((etat) => etat.key);
      this.newCritereRecherche.couleurs = this.couleurImpressionSelected
        .map((etat) => etat.key);
      this.newCritereRecherche.demandeurIds = this.demandeurSelected.map((contact) => {
        return contact.id;
      });
      this.newCritereRecherche.receveurIds = this.receveurSelected.map((contact) => {
        return contact.id;
      });
      this.newCritereRecherche.campagneIds = this.campagneSelected.map((campagne) => {
        return campagne.id;
      });
      this.newCritereRecherche.dispositifIds = this.dispositifSelected.map((dispositif) => {
        return dispositif.id;
      });
      this.newCritereRecherche.clientIds = this.clientSelected.map((client) => {
        return client.id;
      });
      this.newCritereRecherche.graphisteIds = this.graphisteSelected.map((graphiste) => {
        return graphiste.id;
      });
      this.newCritereRecherche.tagIds = this.tagSelected.map((tag) => {
        return tag.id;
      });
      if (this.societeId) {
        this.newCritereRecherche.societeId = this.societeId;
      }
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.demandeurSelected = [];
      this.receveurSelected = [];
      this.clientSelected = [];
      this.couleurImpressionSelected = [];
      this.campagneSelected = [];
      this.dispositifSelected = [];
      this.graphisteSelected = [];
      this.tagSelected = [];
      this.newCritereRecherche = cloneDeep(genererCritereRechercheDemandeImpression());
      this.graphisteSelected = this.newCritereRecherche.graphisteIds
        .map(g => this.utilisateurs.find(u => u.id === g));
      this.etatDemandeImpressionSelected = this.newCritereRecherche.etats
        .map(e => ETAT_DEMANDE_IMPRESSION.find(ed => ed.key === e));
    },
    getFilteredClientTags: debounce(async function getClients(search) {
      this.filteredClients = [];
      if (!search) return;
      this.isFetchingClients = true;
      try {
        const clients = (await getAllTiers(
          {
            query: {
              auto: search,
              societeId: this.societeActiveId,
              estLieuStockage: true,
            },
          },
        )).data.result.items;
        this.filteredClients = clients.filter((client) => {
          return !this.clientSelected.map(
            clientSelected => clientSelected.id,
          ).includes(client.id);
        });
        this.isFetchingClients = false;
      } catch (e) {
        this.isFetchingClients = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredDemandeurTags: debounce(async function getDemandeurs(search) {
      this.filteredDemandeurs = [];
      if (!search) return;
      this.isFetchingDemandeurs = true;
      try {
        const demandeurs = (await getAllContact(
          {
            query: {
              auto: search,
              societeId: this.societeActiveId,
              archive: false,
              type: 'Client',
            },
          },
        )).data.result.items
          .map(demandeur => {
            const prenom = demandeur.prenom ?? '';
            const nom = demandeur.nom ?? '';
            demandeur.prenomNom = `${prenom} ${nom}`.trim();
            return demandeur;
          });
        this.filteredDemandeurs = demandeurs.filter((demandeur) => {
          return !this.demandeurSelected.map(
            demandeurSelected => demandeurSelected.id,
          ).includes(demandeur.id);
        });
        this.isFetchingDemandeurs = false;
      } catch (e) {
        this.isFetchingDemandeurs = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredReceveurTags: debounce(async function getReceveurs(search) {
      this.filteredReceveurs = [];
      if (!search) return;
      this.isFetchingReceveurs = true;
      try {
        const receveurs = (await getAllContact(
          {
            query: {
              auto: search,
              societeId: this.societeActiveId,
              archive: false,
              type: 'Client',
            },
          },
        )).data.result.items
          .map(demandeur => {
            const prenom = demandeur.prenom ?? '';
            const nom = demandeur.nom ?? '';
            demandeur.prenomNom = `${prenom} ${nom}`.trim();
            return demandeur;
          });
        this.filteredReceveurs = receveurs.filter((receveur) => {
          return !this.receveurSelected.map(
            receveurSelected => receveurSelected.id,
          ).includes(receveur.id);
        });
        this.isFetchingReceveurs = false;
      } catch (e) {
        this.isFetchingReceveurs = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredDispositifTags: debounce(async function getDispositifs(search) {
      this.filteredDispositifs = [];
      if (!search) return;
      this.isFetchingDispositif = true;
      try {
        const dispositifs = (await getAllDispositif({
          query: {
            auto: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        this.filteredDispositifs = dispositifs.filter((dispositif) => {
          return !this.dispositifSelected.map(
            dispositifSelected => dispositifSelected.id,
          ).includes(dispositif.id);
        });
        this.isFetchingDispositif = false;
      } catch (e) {
        this.isFetchingDispositif = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredCampagnesTags: debounce(async function getCampagnes(search) {
      this.filteredCampagnes = [];
      if (!search) return;
      this.isFetchingCampagne = true;
      try {
        const campagnes = (await getAllCampagnes({
          query: {
            auto: search,
            societeId: this.societeActiveId,
            actif: true,
          },
        })).data.result.items;
        this.filteredCampagnes = campagnes.filter((campagne) => {
          return !this.campagneSelected.map(
            campagneSelected => campagneSelected.id,
          ).includes(campagne.id);
        });
        this.isFetchingCampagne = false;
      } catch (e) {
        this.isFetchingCampagne = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key]);
        this.newCritereRecherche = cloneDeep(this.value);
        if (this.newCritereRecherche.graphisteIds?.length > 0) {
          this.graphisteSelected = this.newCritereRecherche.graphisteIds
            .map(g => this.utilisateurs.find(u => u.id === g));
        } else {
          this.graphisteSelected = [];
        }
        if (this.newCritereRecherche.etats.length > 0) {
          this.etatDemandeImpressionSelected = this.newCritereRecherche.etats
            .map(e => ETAT_DEMANDE_IMPRESSION.find(ed => ed.key === e));
        }
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getTags(search) {
      return getAllTags({
        query:
          {
            auto: search,
            actif: true,
            moduleTag: this.constantes.DEMANDE_IMPRESSION,
          },
      });
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
    }),
    ...user.mapGetters({
      utilisateur: 'user',
    }),
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    utilisateurs() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
